<svelte:head>
  <script src="https://asteya.network/host/network-sidebar/network-sidebar.js"></script>
</svelte:head>

<style lang="scss">
  :global{

    @media screen and (min-width: 600px) {
      body {
        padding-left: 48px !important;
      }
    }

  .network-sidebar-container.hidden {
    display: none !important;
  }
  
  .dark-mode {
    .network-sidebar-container {
      background: var(--color-blue-gray--700) !important;
      border-right: 1px solid var(--color-blue-gray--800) !important;

    .separator {
      background: var(--color-blue-gray--900) !important;
    }
    .tt {
        background: var(--color-blue-gray--700) !important;
        box-shadow: 0px 1px 3px rgba(255, 255, 255, 0.15) !important;
        .tt-title {
          color: var(--color-blue-gray--50) !important;
        }
        .tt-descr {
          color: var(--color-blue-gray--100) !important;
          span {
            color: var(--color-blue-gray--50) !important;
          }
        }
      }
    }
  }

  .dark-mode .network-sidebar-container .link.selected {
    &:before {
      background: var(--color-fill-library-active) !important;
    }
  }
}
</style>
